

import { instantiate } from './piece-core.uninstantiated.mjs';


const exports = (await instantiate({

})).exports;

export const {
sampleWasmPackageLabel,
memory,
_initialize
} = exports


